import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"
const pathBase = API_ROUTES.SETTINGS.PANEL.AUDIO_BOT

export function addMusicPanel(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editMusicPanel(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteMusicPanel(panelId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { panelId } })
}

export function getMusicPanelList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
